import { render } from "./Tabs.vue?vue&type=template&id=7a132b84&scoped=true&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=7a132b84&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a132b84"]])

export default __exports__